import React from 'react';
import type { AdminError } from './adminApi';

export const SLOW_MESSAGE = 'Too many requests — slowing down';

/** Shared "slow down" banner for a 429 (contract admin-ui "Entry and access"). */
export const SlowBanner: React.FC<{ error: AdminError | null }> = ({ error }) =>
  error?.kind === 'slow' ? <p className="admin-banner admin-banner-warn" role="status">{SLOW_MESSAGE}</p> : null;

/** A panel that could not load: says so and offers a retry, leaving other panels alone (FR-018). */
export const Unavailable: React.FC<{ message: string; onRetry: () => void }> = ({ message, onRetry }) => (
  <div className="admin-banner admin-banner-error" role="alert">
    <span>{message}</span>
    <button type="button" className="admin-button" onClick={onRetry}>Retry</button>
  </div>
);
